<template>
    <!-- 
        Maneki-Meow Gamify
        eSpace
        Public 
          - (Metamask / Non-Matamask)
        Metapass 
          - Maneki-Meow Core
          - Lucky Cat eSpace
          - KaoChai
    -->
    <div class="mint_container">       
            <!-- Wallet panel -->
            <div v-if="idWalletPanel" style="height:40px; padding:5px 0; width:360px; margin:0 auto; ">
                <!-- Right : connect wallet and Balance Display -->
                <div id="wallet_right" style="padding-left:5px; float:right;border-radius:8px; background-color: darkslategrey;">
                    <div style="float:left; text-align: center; line-height: 40px; height: 40px; width:95px;">
                        {{walletBalance}}
                    </div>
                    <el-button v-if="!isConnect" @click="dialogVisible = true" style="float:left; width:120px;border-radius:8px;"> 
                        Connect wallet
                    </el-button>
                    <el-button v-if="isConnect" @click="dialogVisible = true" style="float:left; width:120px;border-radius:8px;" > 
                    {{walletShortAddress}}
                    </el-button>
                </div>

                <!-- Left : install metamask and select network -->
                <div id="wallet_left" style="padding-right:3px; float:right;">
                    <!-- Dialog : Connect Metemask -->
                    <el-dialog width="30%" :visible.sync="dialogVisible">
                        <el-button width="90%" @click="connectWallet()">Metamask </el-button>
                    </el-dialog>
                    <el-button v-if="!isMetamask" style="width:135px; float:right;border-radius:8px;"
                            @click="goToURL('https://metamask.io/')" > Install Metamask
                    </el-button>
                    <el-button v-if="!isChain && isMetamask" style="width:135px; float:right; border-radius: 8px;" 
                                @click="switchNetwork()" > ⚠ Switch network
                    </el-button>
                    <el-button class="btn-network" v-if="isChain" style="width:135px; float:right;border-radius: 8px;" > {{ chainName}}
                    </el-button>
                </div>
        </div>

   
        <div class="content-tab  tab-general">

        <div class="tab-game" v-if="isTabGame">
            <div class="games_details">

                <div class="blockheight"> {{systemEpoch}}</div>
                <div class="myRedepmtion" @click="isMyRedemption = true "> Redeem</div>


                <div class="pool_neko">{{game.tokenPoolReward}} </div>
                <!-- <div class="pool_cfx">{{game.coinPoolReward}} </div> -->

               
                <el-image v-if="metaPass !=11000" @click="goTabMetapass()"
                    style="max-width:165px; max-height:90px;  margin-top:15px; margin-left:65px;  " :src="nftImageURL" >

                    <div slot="placeholder" class="image-slot">
                        Loading<span class="dot">...</span>
                    </div>
                    <div slot="error" class="image-slot"  @click="goTabMetapass()" >
                        <div class="el-icon-picture"></div>
                    </div>
                
                </el-image>
                <div v-if="metaPass ==11000" class="guest-pass" @click="goTabMetapass()"  >
                </div>

                <div class="latestWinner">
                        {{BestScore}}
                </div>


                <div v-if="isManekiNeko" style="position: absolute; margin-left:345px; margin-top:-168px;">
                    <img src="../../src/assets/images/ManekiWaveNeko.png" />
                </div>
                <div v-if="isManekiFish" style="position: absolute; margin-left:345px; margin-top:-168px;">
                    <img src="../../src/assets/images/ManekiWaveFish.png" />
                </div>


                
                
            </div>
            <div class="panel-play">

                <div class="metapass_status">
                    <div v-if="isOwner"> 
                        <span style="background:#12bc00; padding:3px 20px; border-radius: 20px; color:white;">
                        MEOW #{{ metaPass }} ✔
                        </span>
                    </div>

                    <div v-if="!isOwner && metaPass!=10010" > 
                        <span style="background:#ff4e00; padding:3px 25px; border-radius: 20px; color:white;">
                        Not yours ✖
                        </span>
                    </div>

                    <div v-if="!isOwner && metaPass==10010" > 
                        METAPASS-ONLY
                    </div>
                </div>


                <div class="round_details">
                    <div class="tokenDebit"> 
                        {{tokenDebit}} <span style="font-size: 0.8em;">NEKO</span>
                    </div>
                    <div class="win_count">
                       x {{game.tokenFactor}} <span style="font-size: 0.8em;">  </span>
                    </div>
                </div>
                <ul class="doors">
                    <li :class ="item.color"  v-for="(item) in doors" :key="item.id" >
                            <div @click="openThisRoom(item.id)" >{{item.id + 1}} </div>
                    </li>

                    <div style="clear:both;"></div>
                </ul>
            </div>
            <!--Pop out my Redemption history -->
            <div v-if="isMyRedemption" class="internal-popout">
                
                <div style="width:370px; height:210px; padding:15px">
                    <div style="float:right; font-size: 1.5em; cursor: pointer; background-color: #ff4e00; width:30px; height: 30px; border-radius: 50px; text-align: center;"  @click=" isMyRedemption = false"> X </div>
                    <img style="float:left; margin-left:50px; margin-top:40px;" src="../../src/assets/images/Maneki Street_inWallet.png"/>
                </div>

                <div class="neko-balance redeemRow">{{parseInt(Account.tokenBalance/1e18)}} NEKO</div>
                <div class="cfx-balance redeemRow">{{parseInt(Account.coinBalance/1e18)}} CFX</div>
                <div style="color:black; margin:20px 70px; float:left;"> Contract : <a :href="explorer+beckonContract" target="_blank"> {{beckonContract.substring(0, 6)}}...{{beckonContract.substring(38, 42)}}  </a> </div>

            </div>

         

            <!--Pop out Game Over -->
            <div v-if="dialogSubmit" class="internal-popout">
                
                <div style="width:370px; height:230px; padding:15px; ">
                    <el-image
                        style=" float:left; max-height:80px;max-width: 80px; border-radius: 50px; border:4px solid white;" :src="nftImageURL" >
                    </el-image>
                    <div style="float:right; font-size: 1.5em; cursor: pointer;  background-color: #ff4e00; width:30px; height: 30px; border-radius: 50px; text-align: center;"  @click=" dialogSubmit = false"> X </div>
                    <img style="float:left; margin-left:40px;" src="../../src/assets/images/Maneki Street_redeem.png"/>
                </div>

                <div style="width:400px; text-align: center; font-size: 2em; margin-bottom:20px;color: black;">
                {{tokenDebit}} NEKO
                </div>
                <div style="width:400px; text-align: center; font-size: 2em; color: black;">
                <el-button v-if="comboMetapass > 0" style=" background-color: #00c617;width:150px; color:white; border-radius: 50px; border:none; font-size: 0.8em;"  @click="changeMetapass()">
                    Combo  <span style="font-size: 0.7em;"> {{ comboMetapass }} </span>
                </el-button>
                <el-button style="background-color: #00c617;width:150px; color:white; border-radius: 50px; border:none; font-size: 0.8em;"  @click="submitForRewards(tokenDebit)">
                    Redeem
                </el-button>
                </div>
            </div>

            <!--Pop out Metapass Expired -->
            <div v-if="dialogMetapassExpired" class="internal-popout">
                
                <div style="width:370px; height:170px; padding:15px">
                    <el-image
                        style="float:left; max-height:80px;max-width: 80px; border-radius: 50px; border:4px solid white;" :src="nftImageURL" >
                    </el-image>
                    <img style="float:left; margin-left:40px;" src="../../src/assets/images/ManekiGames_Big-lucky.png"/>
                    <div style="float:right; font-size: 1.5em; cursor: pointer; background-color: #ff4e00; width:30px; height: 30px; border-radius: 50px; text-align: center;"  @click=" changeMetapass()"> X </div>
                </div>

                <div style="width:380px; height:150px;  padding:0 10px; color: black; font-size: 1.5em ;  text-align: center;">
                   <span style="color: #ff4e00;">  Redeem again on </span> <br>
                   <span style="font-size:0.5em;"> block number</span><br>
                   {{ Account.epoch + coolingBlock }}<br>
                   <el-progress v-if="systemEpoch > Account.epoch" :percentage = parseInt((systemEpoch-Account.epoch)/coolingBlock*100) status="success" style="width:200px; margin:0 auto; "></el-progress>
                   <span style="color: #ff4e00;"> 
                    {{timeDisplay}}
                    </span>
                </div>

                <div style="width:400px; text-align: center; font-size: 2em; color: black;">
                <el-button style="background-color: #00c617; width:150px; color:white; border-radius: 50px; border:none; font-size: 0.8em;"  @click="goToMode()">
                    Ok
                </el-button>
                </div>
            </div>

            <!--Pop out NEKO Transfered to Wallet -->
            <div v-if="dialogNekoTransfered" class="internal-popout">
                
                <div style="width:370px; height:210px; padding:15px">
                    <div style="float:right; font-size: 1.5em; cursor: pointer; background-color: #ff4e00; width:30px; height: 30px; border-radius: 50px; text-align: center;"  @click=" dialogNekoTransfered = false"> X </div>
                    <img style="float:left; margin-left:50px; margin-top:40px;" src="../../src/assets/images/Maneki Street_inWallet.png"/>
                </div>

                <div v-if="isTransferNeko" style="width:380px; height:100px;  padding:0 10px; color: black; font-size: 1.5em ;  text-align: center;">
                    Transfering Neko token ... 
                </div>

                <div v-if="!isTransferNeko" style="width:380px; height:100px;  padding:0 10px; color: black; font-size: 1.5em ;  text-align: center;">
                    Redemption successful! <br>
                    Neko token had transfered<br> into your wallet<br>
                </div>

                <div v-if="!isTransferNeko" style="width:400px; text-align: center; font-size: 2em; color: black;">
                    <el-button style="background-color: #00c617; width:150px; color:white; border-radius: 50px; border:none; font-size: 0.8em;"  @click="goToMode()">
                        Ok
                    </el-button>
                </div>
            </div>
            
            <!--Pop out Koban winner -->
            <div v-if="dialogWinKoban" class="internal-popout">
                
                <div style="width:370px; height:170px; padding:15px">
                    <el-image
                        style="float:left; max-height:80px;max-width: 80px; border-radius: 50px; border:4px solid white;" :src="nftImageURL" >
                    </el-image>
                    <img style="float:left; margin-left:40px;" src="../../src/assets/images/ManekiGames_koban.png"/>
                    <div style="float:right; font-size: 1.5em; cursor: pointer; background-color: #ff4e00; width:30px; height: 30px; border-radius: 50px; text-align: center;"  @click=" dialogMetapassExpired = false"> X </div>
                </div>

                <div style="width:380px; height:150px;  padding:0 10px; color: black; font-size: 1.5em ;  text-align: center;">
                   <span style="color: #ff4e00;">  Congratulation! <br>You are the Koban winner  </span> <br>
                {{ kobanToken }} NEKO <br>
                Bonus {{ kobanCoin }} CFX
                </div>

                <div style="width:400px; text-align: center; font-size: 2em; color: black;">
                <el-button style="background-color: #00c617; width:150px; color:white; border-radius: 50px; border:none; font-size: 0.8em;"  @click="changeMetapass()">
                    Ok
                </el-button>
                </div>

            </div>

            <!--Pop out Guest : Game Over -->
            <div v-if="dialogGuestGameOver" class="internal-popout">
                <div style="width:370px; height:200px; padding:15px">


                    <img style="float:left; max-height:80px;max-width: 80px; border-radius: 50px; border:4px solid #00c617; background-color: white;" src="../../src/assets/images/Maneki Street_Guest.png" />
                    
                    <div style="float:right; font-size: 1.5em; cursor: pointer; background-color: #ff4e00; width:30px; height: 30px; border-radius: 50px; text-align: center;"  @click=" dialogGuestGameOver = false"> X </div>
                    
                    <img style="float:left; margin-left:-20px;margin-top:60px;" src="../../src/assets/images/Maneki-neko.png"/>
                </div>

                <div style="width:400px; text-align: center; font-size: 2em; padding:5px;color: black;">
                {{tokenDebit}} NEKO
                </div>
                <div style="width:400px; text-align: center; font-size: 2em; color: black;">
                    
                    <div v-if=" tokenDebit >= 10 && systemEpoch < Account.epoch + coolingBlock" style="width:150px; margin:0 auto;"> 
                        <el-button  style="background-color:#CCC;width:150px; color:white; border-radius: 50px; border:none; font-size: 0.8em;" >
                            Redeem
                        </el-button> 

                        <el-progress v-if="systemEpoch > Account.epoch" :percentage = parseInt((systemEpoch-Account.epoch)/coolingBlock*100) status="success" style="width:100px; margin:0 auto; padding:0px; "></el-progress>
                        <span style="font-size: 0.7em;"> {{ timeDisplay }} </span>
                    </div>
                    <div v-if=" tokenDebit >= 10 && systemEpoch > Account.epoch + coolingBlock" style="width:150px; margin:0 auto;"> 
                        <el-button  style="background-color: #00c617;width:150px; color:white; border-radius: 50px; border:none; font-size: 0.8em;"  @click="submitForRewards(10)">
                            Redeem
                        </el-button> <br>
                    </div>
                </div>
            </div>


        </div>

        <!-- Tab Maneki Meow as Metapass-->
        <div class="tab-metapass " v-if="isTabMetapass">
            <div style="width:480px; height:60px;">
                <h2 v-on:click="goToMode()" style="width:150px; float:left;"> Metapass 
                </h2> 
                <img style= "width:150px; float:right; padding:15px;" src="../../src/assets/images/logo-maneki_logo.png"/>
            </div>

            <!-- Wallet connectd -->
            <div v-if="isFluentConnect" class="metapass-wallet-connection"  >
                <div class="meow-balance">{{accountNFTBalance}} MEOW</div> 
            </div>

            <!-- Wallet not connected -->
            <div v-if="!isFluentConnect" class="metapass-wallet-connection" style="height:200px;" >
                    <div style="width:370px; padding:32px; float:left;  margin-bottom:5px;">
                    Connect Conflux Fluent Wallet to use <br>Maneki-Meow as Metapass
                    </div>
                    <el-button style="margin:0 auto; font-size: 1.5em; margin-left:30px;" @click="connectButton()"> 
                        Connect wallet 
                        <img style="width:30px; margin-left:20px; float:right; " src="../../src/assets/images/fluent-logo.png" />
                    </el-button>
            </div>


            <ul v-if="isFluentConnect">
                <li v-for="(item2) in myPass" :key="item2.id" >
                    <div style="padding:8px 5px;" @click="selectMetapass(item2.id)" > 
                        MEOW #{{item2.id}} 
                        <div v-if="item2.coolingTime == true " style="float:right; color:gray;"> ♥ </div>
                        <div v-else style="float:right; color:red;">  ♥ </div>
                    </div>

                    <el-image v-if="item2.coolingTime == true " style="opacity:0.5; max-width:180px; max-height:180px; border-radius: 5px; " :src="item2.img" :fit="'cover'" >
                        <div slot="placeholder" class="image-slot">
                            Loading<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                            <div class="el-icon-picture"></div>
                        </div>
                    </el-image>

                    <el-image v-if="item2.coolingTime == false " style="max-width:180px; max-height:180px; border-radius: 5px; " :src="item2.img" :fit="'cover'" @click="selectMetapass(item2.id)" >
                        <div slot="placeholder" class="image-slot">
                            Loading<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                            <div class="el-icon-picture"></div>
                        </div>
                    </el-image>
                </li>
            </ul>

            <div style="clear:both;"></div>

            <!--Pop out connect fluent wallet -->
            <div v-if="isFluentWallet" class="internal-popout-metapass">
                <div style="width:370px; height:40px; padding:15px">
                    <div style="float:right; font-size: 1.5em; cursor: pointer; background-color: #ff4e00; width:30px; height: 30px; border-radius: 50px; text-align: center;"  @click=" isFluentWallet = false"> X </div>
                </div>
            
                <div style="font-size:1.8em; padding-top:50px; padding-bottom:20px; width:350px; margin:0 auto; "> 
                    <span style="color:yellow; font-size:0.7em;"></span> Connect to a wallet
                </div>

                <div class="walletButton">
                    <a href="https://fluentwallet.com/" target="_blank" >
                        <div style="width:250px; height:35px; color:black; font-size:1.7em; font-weight:100; float:left; "> Install Fluent Wallet </div>
                        <img style="width:35px; float:left; " src="../../src/assets/images/fluent-logo.png" />
                    </a>
                </div>
                <div style="color:#666; font-size:1em; padding-top:80px; width:350px; margin:0 auto; "> 
                    New to Conflux? <a href="https://fluentwallet.com/" target="_blank" style="color:#666;"> Learn more about wallet </a>
                </div>
            </div>



            <!--Pop out connect fluent wallet -->
            <div v-if="isFluentWalletInstall" class="internal-popout-metapass">
                <div style="width:370px; height:40px; padding:15px">
                    <div style="float:right; font-size: 1.5em; cursor: pointer; background-color: #ff4e00; width:30px; height: 30px; border-radius: 50px; text-align: center;"  @click=" isFluentWalletInstall = false"> X </div>
                </div>
                <div style="font-size:1.8em; padding-top:50px; padding-bottom:20px; width:350px; margin:0 auto; "> 
                    <span style="color:yellow; font-size:0.7em;"></span> Connect to a wallet
                </div>
                <div class="walletButton" @click="authorizedWallet()">
                    <div style="width:250px; height:35px; color:black; font-size:1.7em; font-weight:100; float:left; "> Fluent Wallet </div>
                    <img style="width:35px; float:left; " src="../../src/assets/images/fluent-logo.png" />
                </div>
                <div style="color:#666; font-size:1em; padding-top:80px; width:350px; margin:0 auto; "> 
                    New to Conflux? <a href="https://fluentwallet.com/" target="_blank" style="color:#666;"> Learn more about wallet </a>
                </div>
               
            </div>





        </div>

        <!-- 
            Tab Treasure as Metapass
            Require to connect eSpace Wallet
            - setup
        -->
        <div class="tab-metapass " v-if="isTabTreasure">
            <div style="width:480px; height:60px;">
                <h2 v-on:click="goToMode()" style="width:150px; float:left;"> Metapass 
                </h2> <br>
                <p> Treasurer</p>
                <img style="width:30px; margin-left:20px; float:right; " src="../../src/assets/images/Maneki Street_Treasurer.png" @click="selectMetapass(11111)" />
                
            </div>

            <!-- Wallet connectd -->
            <div v-if="isMetamaskConnected" class="metapass-wallet-connection"  >
                <div class="meow-balance"> Well done! You are ready play.</div> 
            </div>

            <!-- Wallet not connected -->
            <div v-if="!isMetamaskConnected" class="metapass-wallet-connection" style="height:200px;" >
                    <div style="width:370px; padding:32px; float:left;  margin-bottom:5px;">
                    Connect Metamask Wallet with Conflux eSpace Network
                    </div>
                    <el-button style="margin:0 auto; font-size: 1.5em; margin-left:30px;" @click="connectButton()"> 
                        Connect wallet 
                        <img style="width:30px; margin-left:20px; float:right; " src="../../src/assets/images/fluent-logo.png" />
                    </el-button>
            </div>


            

            <div style="clear:both;"></div>

            <!--Pop out connect fluent wallet -->
            <div v-if="isFluentWallet" class="internal-popout-metapass">
                <div style="width:370px; height:40px; padding:15px">
                    <div style="float:right; font-size: 1.5em; cursor: pointer; background-color: #ff4e00; width:30px; height: 30px; border-radius: 50px; text-align: center;"  @click=" isFluentWallet = false"> X </div>
                </div>
            
                <div style="font-size:1.8em; padding-top:50px; padding-bottom:20px; width:350px; margin:0 auto; "> 
                    <span style="color:yellow; font-size:0.7em;"></span> Connect to a wallet
                </div>

                <div class="walletButton">
                    <a href="https://fluentwallet.com/" target="_blank" >
                        <div style="width:250px; height:35px; color:black; font-size:1.7em; font-weight:100; float:left; "> Install Fluent Wallet </div>
                        <img style="width:35px; float:left; " src="../../src/assets/images/fluent-logo.png" />
                    </a>
                </div>
                <div style="color:#666; font-size:1em; padding-top:80px; width:350px; margin:0 auto; "> 
                    New to Conflux? <a href="https://fluentwallet.com/" target="_blank" style="color:#666;"> Learn more about wallet </a>
                </div>
            </div>



            <!--Pop out connect fluent wallet -->
            <div v-if="isFluentWalletInstall" class="internal-popout-metapass">
                <div style="width:370px; height:40px; padding:15px">
                    <div style="float:right; font-size: 1.5em; cursor: pointer; background-color: #ff4e00; width:30px; height: 30px; border-radius: 50px; text-align: center;"  @click=" isFluentWalletInstall = false"> X </div>
                </div>
                <div style="font-size:1.8em; padding-top:50px; padding-bottom:20px; width:350px; margin:0 auto; "> 
                    <span style="color:yellow; font-size:0.7em;"></span> Connect to a wallet
                </div>
                <div class="walletButton" @click="authorizedWallet()">
                    <div style="width:250px; height:35px; color:black; font-size:1.7em; font-weight:100; float:left; "> Fluent Wallet </div>
                    <img style="width:35px; float:left; " src="../../src/assets/images/fluent-logo.png" />
                </div>
                <div style="color:#666; font-size:1em; padding-top:80px; width:350px; margin:0 auto; "> 
                    New to Conflux? <a href="https://fluentwallet.com/" target="_blank" style="color:#666;"> Learn more about wallet </a>
                </div>
               
            </div>





        </div>
        <!-- mode tab-->
        <div class="tab-mode " v-if="isTabMode">
                <h2> Select your Metapass
                </h2> 
                <ul>
                <li>
                    <div style="padding:8px 0;" @click="selectMetapass(11000)" > 
                        <img style="max-width:180px; max-height:180px; border-radius: 5px;" src="../../src/assets/images/Maneki Street_Treasurer.png" />
                    </div>
                </li>
                <li>


                    <div v-if="systemEpoch < Account.epoch + coolingBlock" style="padding:5px 0;color: black; font-size: 1.5em ;  text-align: center;"  > 
                        <img style="max-width:140px; max-height:140px; border-radius: 5px; " src="../../src/assets/images/Maneki Street_Metapass.png" /><br>
                        <span style="font-size:0.5em;padding:0;"> block number</span><br>
                        {{ Account.epoch + coolingBlock }}<br>
                        <el-progress v-if="systemEpoch > Account.epoch" :percentage = parseInt((systemEpoch-Account.epoch)/coolingBlock*100) status="success" style="width:180px; margin:0 auto; "></el-progress>
                        <br>
                        {{timeDisplay}}
                    </div>

                    <div v-if="systemEpoch > Account.epoch + coolingBlock" style="padding:5px 0;color: black; font-size: 1.5em ;  text-align: center;" @click="goToMetapass()" > 
                        <img style="max-width:180px; max-height:180px; border-radius: 5px;" src="../../src/assets/images/Maneki Street_Metapass.png" /><br>
                    </div>
                </li>

                <div style="clear:both;"></div>
                </ul>

        </div>


        <div class="tab-koban" v-if="isTabKoban" @click="goToMode()">
            <div class="tab-koban-top">
                <div style=" float : left;color:white;  margin-top: 140px; margin-left: 200px; width: 200px; height:40; font-size:2.5em;">{{game.tokenPoolReward}} </div>
                <div style=" float : right;color:white; margin-top: 188px; margin-right: 36px; width: 40px; height:40; font-size:2em; text-align: center;"> {{ totalCombos }}</div>
            </div>
            <div class="koban-winners">

                <ul>
                <li  v-for="(item2, index) in latestCombos" :key="index">
                    <el-image style="max-width:70px; max-height:70px; border-radius: 50px; float:left; margin-right:10px; " :src="item2.metapassIMG" :fit="'cover'" >
                        <div slot="placeholder" class="image-slot">
                            Loading<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                            <div class="el-icon-picture"></div>
                        </div>
                    </el-image>

                    <div> MEOW #{{item2.metapass}} , {{item2.winnerWallet.slice(0, 9)}} ... {{ item2.winnerWallet.slice(45,50)}} </div>
                    <div> Koban value : {{ item2.tokenPool/1e18}} NEKO </div>
                    <div> Bonus : {{ item2.coinPool/1e18 }}CFX </div> 
             
                </li>
                </ul>

                <div style="width:480px; height:100px; text-align: center; font-size: 2em; color: black;">
                    <el-button style="margin:0 auto; background-color: #00c617; width:150px; color:white; border-radius: 50px; border:none;"  @click="goToMode()">
                        Play now
                    </el-button>
                </div>
            </div>
        </div>


        <!-- Start Screen : Play  -->
        <div class="tab-howToPlay" v-if="ishowToPlay && isMetamask && isChain" @click="goToMode()">
            <div style="width:310px;  height:250px; margin:0 auto; margin-top:304px; text-align: right;font-size:2.2em; color:white; "> 
                <div style="font-size:0.5em; margin-top:-25px; color:#666; padding-bottom:5px;"> Block {{systemEpoch}}</div>
                <div style=" height:52px; font-weight: 600; "> {{ globalBeckoning.toLocaleString('en-US') }}</div>
                <div style=" height:52px; font-weight: 600;">{{ parseInt(game.tokenPoolReward).toLocaleString('en-US') }} </div>
                <div style=" height:52px; font-weight: 600;"> {{ nekoRedeemed.toLocaleString('en-US') }}</div>
                <el-button  
                  style="background-color: #00c617;width:150px; color:white; border-radius: 50px; border:none; font-size: 0.8em; margin:0 auto; margin-top:40px;"  
                  @click="goToMode()">
                    Play
                </el-button> 
            </div>
        </div>


        <!-- Start Screen : Install Metamask -->
        <div class="tab-start-empty" v-if="ishowToPlay && !isMetamask" >
            <div style="width:310px;  height:230px; margin:0 auto; font-size:1.2em; margin-top:314px;  ">
                Welcome to Web3!<br>
                <img src="../../src/assets/images/Maneki-Metamask-Conflux.png" /><br>
                
                <el-button  
                  style="background-color: #00c617;width:200px; color:white; border-radius: 50px; border:none; font-size:1em; margin:0 auto; margin-top:20px;"  
                  @click="goToURL('https://metamask.io/')">
                    Install Metamask 
                </el-button> 
            </div>
        </div>



        <!-- Start Screen : Switch Network -->
        <div class="tab-start-empty" v-if="ishowToPlay && isMetamask && !isChain" >
            <div style="width:310px;  height:230px; margin:0 auto; font-size:1.2em; margin-top:314px;  ">
                <br>
                <img src="../../src/assets/images/Maneki-Conflux-eSpace.png" /><br>
                
                <el-button  
                  style="background-color: #00c617;width:200px; color:white; border-radius: 50px; border:none; font-size:1em; margin:0 auto; margin-top:20px;"  
                  @click="switchNetwork()">
                  ⚠ Switch network
                </el-button> 
            </div>
        </div>



        <div style="clear:both;"></div>
        </div>

 
    


        <div v-if="dialogLuckyPacket" class="dialog-container" >

            <div class="dialog-wrap"  @click="dialogLuckyPacket = false">
                <img src="../../src/assets/images/ManekiGames_icon-lose.png" /><br>
                {{life}} ♥ 
            </div>
        </div>



        <!-- Download wallet -->
        <el-dialog  :visible.sync="downloadWallet">

            <div class="dialog-input-wrap">


                <div class="dialog-content" style="height:250px;">
                    <div style="margin: 0 auto; color:white; font-size:1.6em; text-align:center; padding-top:50px; padding-bottom:5px; width:350px; ">
                        <span style="color:yellow; font-size:0.8em;">Maneki-MeowをConfluxウォレットで<br>安全にチェーンに保管する</span><br>
                        Store Maneki-Meow <br>safely on-chain with
                        <br>
                        <img  style="margin-top:30px; width:220px; background:white; border-radius:5px; padding:20px;" src="https://fluentwallet.com/assets/logo.b3425fdb.svg"  />
                    </div>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button style="font-size:1.2em; margin-top:30px; background-color:#ffe000; color:#ff3600; border:1px solid #ff3600; "  > 
                        <a href="https://chrome.google.com/webstore/detail/fluent/eokbbaidfgdndnljmffldfgjklpjkdoi" target="_blank">
                            Free downlaod
                        </a>
                    </el-button>
                        <div style="color:#CCC;padding-top:5px;"> for Chrome </div>
                    <div style="margin-top:60px;"> 
                        New to Conflux? 
                        <a href="https://fluentwallet.com/" target="_blank"> Learn more about wallets</a>
                    </div> 
                </div>

            </div>
        </el-dialog>



      <!-- Activate address Fluent -->
        <el-dialog  :visible.sync="dialogActivate" :close-on-click-modal="false" >
            <div class="dialog-input-wrap">
                <div class="dialog-content">
                    <div style="color:white; font-size:1.8em; padding-top:120px; padding-bottom:20px; width:350px; margin:0 auto; "> 
                        <span style="color:yellow; font-size:0.7em;"></span> Connect to a wallet
                    </div>
                    <div class="walletButton" @click="authorizedWallet()">
                        <div style="width:250px; height:35px; color:black; font-size:1.7em; font-weight:100; float:left; "> Fluent Wallet </div>
                        <img style="width:35px; float:left; " src="../../src/assets/images/fluent-logo.png" />
                    </div>
                    <div style="color:#666; font-size:1em; padding-top:80px; width:350px; margin:0 auto; "> 
                        New to Conflux? <a href="https://fluentwallet.com/" target="_blank" style="color:#666;"> Learn more about wallet </a>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
    
</template>

<script>


// Contract : Collectibles 
//import abi_collectible from '../web3/abi_collectible';
import abi_nft_meow from '../web3/abi_nft_meow';
import abi_beckoning from '../web3/abi_beckoning';
import abi_neko from '../web3/abi_neko';



import getWeb3 from '../web3/web3';

const targetChain = '0x47';
const contract_beckoning = '0x9f9A180bAc00f524c48E5B842bbb3A08da100705';
const contract_neko = '0x41b49c45a1A033e85704b3C0cb34C37d202e42c9';





// --- below is the conflux core use

//Conflux SDK
const { format,Conflux } = require('js-conflux-sdk');


const provider = window.conflux
console.log(' connected Wallet and network : ',provider)



// Secind Network - Conflux Core Mainnet
// use to get Meow as Metapass
const confluxCore = new Conflux({
  url: 'https://main.confluxrpc.com',
  networkId: 1029,
});

const contract_nft_meow =  confluxCore.Contract({
    abi:abi_nft_meow, 
    address:'cfx:acedfgnc6tp0g8t2yy35gmr4pw4cjk7sgus4fmktnn'
});




const path_Image = 'https://m.maneki.market/';

//const path_TxLogURL = 'https://testnet.confluxscan.io/transaction/';
//const path_Metadata = 'https://t2metadata.maneki.market/token/'



export default {
  name: 'App',
  data() {
    return {


        dialogVisible: false,
        idWalletPanel: true,
        isMetamask: false,
        isChain : false,
        chainId : 0,
        chainName : 'eSpace Testnet',
        walletBalance : '',

        systemEpoch :0,
        playMusic : true,
        audio : new Audio(require('../../src/assets/music/bgmusic-festival.mp3')),
        grid : 5,
        authKey : '0x000000000000000000000000697cb3a91d22f4cb39aeea7eb4a410fedd0bbe06',
        metaPass : 10010,
        timer : 0,
        tokenDebit : 0,
        life : 1,
        BestScore : 0,
        kobanCoin :  2,
        kobanToken : 2,
        explorer : 'https://evmtestnet.confluxscan.io/address/',
        beckonContract : contract_beckoning,

        startBlock : 97088857,
        nekoRedeemed : 501323,
        nekoStartingDeposit : 1000000000000000000000000,
        startBeckoning : 9122899,
        globalBeckoning : 9122899,
        

        //estTimeDisctance : 60000,
        //coolingBlock : 130,

        estTimeDisctance : 900000,
        coolingBlock : 1950,

        autoLoadTimer : '',
        comboMetapass : 5,
        

        isTabGame : false,
        isTabMetapass : false,
        isTabTreasure : false,
        isTabGuest : false,
        isTabKoban : false,
        ishowToPlay : true,
        isManekiNeko : false,
        isManekiFish : false,
        isTransferNeko : true,
        isTabMode : false,
        isMyRedemption : false,
        isFluentWallet : false,
        isFluentWalletInstall : false,

        game :{
            range           :1, 
            coinPoolReward  :0, 
            tokenPoolReward :0,
            coinFactor      :0, 
            tokenFactor     :0, 
            tokenAddress    :0
        },

        myPass : [],
        doors : [],
   
        round : [],

        collectedNeko :[],

        latestWinner : [],

        latestCombos : [],
        combosDisplay : [],

        winCount:0,
        totalRounds :0,
        roomOpened : 0,
        isGameOver : false,


        dialogSubmit : false,
        dialogLuckyPacket : false,
        dialogMetapassExpired : false,
        dialogGuestGameOver : false,
        dialogNekoTransfered : false,
        dialogWinKoban : false,
        
        initLoad : false,
        timeDisplay : '',
        clock:0,
        countDownDate : 0,

        Account : {
            playerWallet: '',
            tokenAmount : 0,
            coinAmount  : 0,
            epoch :0
        },

        accountNetwork1: null,

        isConnect: false,
        isFluentConnect : false,
        isMetamaskConnected : false,
        accountCFXBalance : 0,
        accountNekoBalance : 0,
        accountNFTBalance : 0,
        accAddress : '0x0',
        accAddressStorten : '0x0',
        dialogActivate : false,
        nftImageURL : '',
        
        isMetapass : false,
        isOwner : false,

        endDuration : 40,
        endProgress : 0,


        web3: null,
        account:null,
        poolBalance:0,
        selected : 0,
        display :{
            isConnect : false,
            isGuardian : true,
            isName : false,
            isWish : true,
            isPayment : false,
        },
        NFT : {
            owned:0,
            supply:0,
            balance:0
        },
        contract :{
            collectibles:null,
            payment:null,
            neko:null,
            ERC20:null
        },
        payment : {
            tokens : [],
            key : 0,
        },
        dialog :{
            mint :false,
            success: false,
            gamma : false,
            wish : false,
            name : false,
            payment : false,
            painting : false,
            redeem : false,
        },
        dialogTableVisible: false,
        form: {
            name: '猫の守護者',
            guardian: '',
            payment: '',
            wish: '',
        },
        newNFT : {
            id: '',
            img: '',
            wish: '',
            name: '',
            guardian : '',
            guardianIMG :'',
            DNA: '',
            gammaID: '',
            power: '',
            refCount: '',
        },
        wishRules: {
                wish: [
                    { required: true, message: 'Please make a wish', trigger: 'blur' },
                    { min: 0, max: 110, message: 'Message within 5 to 110 charaters', trigger: 'blur' }
                ],
        },    
        nameRules: {
                name: [
                    { required: true, message: 'Give a name', trigger: 'blur' },
                    { min: 0, max: 20, message: 'Message within 3 to 20 charaters', trigger: 'blur' }
                ],
        },  
        paymentRules : {
                payment: [
                    { required: true, message: 'select a payment token', trigger: 'change' }
                ]
        },          
        formLabelWidth: '120',
        downloadWallet: false,
    };
  },
  created() {
        this.form.payment = 0;
  },
  mounted() {
// start espace

        window.ethereum.on('accountsChanged', function (accounts) {
            // Time to reload your interface with accounts[0]!
            this.accountNetwork1 = accounts[0];
            console.log('change account :', this.accountNetwork1);
        })

        window.ethereum.on('chainChanged', function (res) {
            // Time to reload your interface with the new networkId
            this.chainId = res;
            if (targetChain == res){
                this.isChain = true;
                console.log('is eSpace');
                console.log('correct network ', res);
            } else {
                this.isChain = false;
                this.isConnect = false;
                this.isMetamask = false;
                console.log('wrong network ', res);
            }
            console.log('isChain :', this.isChain);
            location.reload();     
        })

        getWeb3().then((res) => {
            this.web3 = res;


            this.contract.beckoning = new this.web3.eth.Contract(abi_beckoning, contract_beckoning);
            this.contract.neko = new this.web3.eth.Contract(abi_neko, contract_neko);

            this.isMetamaskInstalled();
            this.iseSpaceTestnet();
            //this.getNFTSupply();
            

        }).catch((err) => {
            console.log(err, 'err!!');
        });
        
        console.log('Beckoning : ', contract_beckoning);

// end - espace 
      this.endDateCount()

        this.initWallet();
 
        provider.on('accountsChanged', accounts => {
            this.accAddressStorten= accounts[0]
            this.initWallet()
            this.isFluentConnect = true
            this.dialogActivate = false
            console.log('accountsChanged = ', accounts)
        })
 
        provider.on('chainChanged', chainId => {
            console.log('chainChanged,  = ', chainId)
            provider.request({method: 'cfx_netVersion'}).then(networkId => {
            console.log('networkId,  = ', networkId)
            })
        })


  },
  methods:{ 
// conflux eSpace Start
    
   
    async iseSpaceTestnet(){
        console.log('sohem')
        if (window.ethereum) {
            const currentChainId = await window.ethereum.request({
            method: 'eth_chainId',
            });

            // return true if network id is the same
            if (currentChainId == targetChain){ 
                this.isChain =true;
                this.chainId = currentChainId;
                this.chainName = 'eSpace Testnet';                 
                this.connectWallet();
                return true;
            }
            return false;
        }

    },
    async switchNetwork(){
        try {
        await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x47' }],
        });
        } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902 || switchError.code === -32603) {
            try {
            await window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [
                    {   
                    chainId: '0x47',
                    chainName: 'Conflux eSpace (Testnet)',
                    rpcUrls: ['https://evmtestnet.confluxrpc.com'],
                    nativeCurrency: {
                        name: "Conflux",
                        symbol: "CFX",
                        decimals: 18
                    },
                    blockExplorerUrls: ["https://evmtestnet.confluxscan.net"]
                    },
                ],

            });

            } catch (addError) {
            // handle "add" error
            }
        }
        // handle other "switch" errors
        }
    },
    async switchNetwork2(){
        const targetNetworkId = '0x47';

        await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: targetNetworkId }],
        }).then((res) => { 

            console.log('switch : ', res)
            this.chainId = targetNetworkId;
            this.isChain = true; 
            this.connectWallet ();

        }).catch(error => {
        
            if (error.code === 4902) {

                this.wallet_addEthereumChain()
                console.log ('ham cai lo')

            }
        }
            
        )

    },
    async wallet_addEthereumChain(){
        await window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [
                    {   
                    chainId: '0x47',
                    chainName: 'Conflux eSpace (Testnet)',
                    rpcUrls: ['https://evmtestnet.confluxrpc.com'],
                    nativeCurrency: {
                        name: "Conflux",
                        symbol: "CFX",
                        decimals: 18
                    },
                    blockExplorerUrls: ["https://evmtestnet.confluxscan.net"]
                    },
                ],

                });
    },
    async isMetamaskInstalled (){
        if (typeof window.ethereum !== 'undefined') {
        console.log('MetaMask is installed!');

        this.isMetamask = true;

        } else {

        console.log('MetaMask not installed!');
            // do something 
        }
    },
    goToURL(_url){
        //window.location.href = _url;

        window.open(_url, '_blank');
    },
    async connectWallet () {

        console.log('in connectWallet fx')

        if(this.chainId != targetChain){
            this.switchNetwork();
        } else {

            await window.ethereum.request({ method: "eth_requestAccounts", }).then((accounts) => {
                [this.accountNetwork1] = accounts;
                    if(this.accountNetwork1!=null){
                        this.isConnect = true;
                        this.dialogVisible = false;
                        this.walletShortAddress = this.accountNetwork1.substring(0, 6) + '...' + this.accountNetwork1.substring(38, 42);

                        this.web3.eth.getBalance(this.accountNetwork1).then((res) => {
                            this.walletBalance = (res.toString()/1e18).toFixed(0) + ' CFX';
                        });
                        this.fetchData();
                    } else {
                        //request login metamask 
                        this.idWalletPanel = true;
                    }
            })
            console.log('connect wallet')
        }

    },






// Conflux CORE Start 
        playBgMusic (){
            this.audio.play();
            this.audio.volume = 0.1;
        },
        playCollectCoinSound(){
         var audio = new Audio(require('../../src/assets/music/collectCoin.wav')); 
         audio.play();
        },
        playFishSound(){
         var audio = new Audio(require('../../src/assets/music/fish.wav')); 
         audio.play();
        },
        playGameOverSound(){
         var audio = new Audio(require('../../src/assets/music/bell-ring.mp3')); 
         audio.play();
        },
        playDogSound(){
         var audio = new Audio(require('../../src/assets/music/dogBuck.wav')); 
         audio.play();
        },
        playPayoutSound(){
         var audio = new Audio(require('../../src/assets/music/coins-drop.mp3')); 
         audio.play();
        },
        playCashRegister(){
         var audio = new Audio(require('../../src/assets/music/cash-register.mp3')); 
         audio.play();
        },
        openNotification(_message ) {
            this.$notify.success({
            title: 'Door ' + (this.roomOpened + 1),
            message: _message,
            offset: 100,
            duration : 10000,
            position: 'top-left'
            });
        },

        endDateCount(){

            const date = new Date();

            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();

            // This arrangement can be altered based on how we want the date's format to appear.
            let currentDate = `${month}/${day}/${year}`;

            const date1 = new Date('10/25/2022');
            const date2 = new Date(currentDate);
            const diffTime = Math.abs(date2 - date1);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            console.log(diffTime + " milliseconds");
            console.log(diffDays + " days");

            this.endProgress = diffDays
        },
        goToFluentPopOut(){
            console.log('goToFluentPop out')
            this.isFluentWallet = true
            console.log('goToFluentPop out')
        },
        gotoSupportChat(){
             window.open('https://telegram.me/maneki2699', '_blank');
            //window.location.href = "https://telegram.me/maneki2699";
            
        },
        goToMode(){
            // play bg music 
            this.playCashRegister();
            this.playBgMusic()
            this.ishowToPlay = false
            this.isTabMode = true
            this.isTabKoban = false
            this.isTabGame = false
            this.dialogGuestGameOver = false
            this.isTabMetapass = false

            this.game.tokenFactor = 1
            this.tokenDebit = 0
        },
        goToKoban(){

            this.ishowToPlay = false
            this.isTabKoban = true
            this.playBgMusic()
        },
        goToMetapass(){
            this.isTabMode = false
            this.isTabKoban = false
            this.isTabMetapass= true
        },
        goToTreasurer(){
            this.isTabMode = false
            this.isTabKoban = false
            this.isTabTreasure= true
        },
        initWallet(){
            
            // Fluent Extention Installed?
            if (window?.conflux?.isFluent) {
                // Installed
                this.walletInitialized()
            } else {
                //Fluent Not install, Request to make installation
                console.log('Fluent is not connected, please try refresh this page or restart your browser.')
                // Appear dialog , LINK - request install Fluent 
                //this.dialogInstall = true
            }
        },
        connectButton(){
            
            // Fluent Extention Installed?
            if (window?.conflux?.isFluent) {
                // Installed, Request authorized with wallet
                //this.walletInitialized()
                //this.dialogActivate = true

                this.isFluentWalletInstall = true

            } else {
                //Fluent Not install, Request to make installation
                console.log('Fluent is not connected, please try refresh this page or restart your browser.')
                // Appear dialog , LINK - request install Fluent 
                //this.dialogInstall = true

                this.isFluentWallet = true
            }
        },

        goMarketplace(){
            window.location.href = 'https://art.maneki.market/#/marketGroup/550000/650000';
        },
        goCollection(){
            window.location.href = 'https://art.maneki.market/#/wallet';
        },
        async authorizedWallet(){
            console.log('Requesting account')
            provider
            .request({
            method: 'cfx_requestAccounts',
            })
            .then(this.walletInitialized())
            .catch(error => console.error('error', error.message || error))
        },


        async walletInitialized() {
            console.log('Fluent Wallet Connected')

            provider.request({method: 'wallet_getFluentMetadata'}).then(({version}) => {
                console.log('Fluent version :',version);
            })

            const [chainId, networkId, alreadyAuthedAddresses] = await Promise.all([
            provider.request({method: 'cfx_chainId'}),
            provider.request({method: 'cfx_netVersion'}),
            provider.request({method: 'cfx_accounts'}),
            ])

            console.log('initialized')
            console.log('chainId :',  chainId)
            console.log('networkId: ', networkId)          
            
            if (!alreadyAuthedAddresses.length) {
                // Appear Dialog - Coneect to a wallet FLUENT
                console.log ('no address',alreadyAuthedAddresses )

            } else {
                
                this.accAddress = alreadyAuthedAddresses[0]
                this.accAddressStorten  = alreadyAuthedAddresses[0]

                // convert Testnet Address to Mainnet 
                this.accMainnetCore = format.address(format.hexAddress(alreadyAuthedAddresses[0]), 1029 );
                
                console.log('Conflux-Core Testnet :', alreadyAuthedAddresses[0])
                console.log('Conflux-Core Mainnet :', this.accMainnetCore)


                this.isFluentConnect = true
                this.fetchCoreData()
                
            }            


        },
        fetchCoreData(){     
                this.isFluentWallet = false
                this.isFluentWalletInstall = false

                this.getNFTBalance();
                this.getNFTDetails();
                this.getURI();
                this.isMetapassOwner();
                this.getMyMetapass();
                
        },

        fetchData(){

                this.getLatestBlock()

                this.getNekoRedeemed()

                // load user guide
                //this.LoadHowToPlay ()
                this.getAccount();
                this.getTotalRounds();
                this.getGameDetails();
                this.newRound()
                this.generateGird()
                this.getComboWinners()
                this.getBestScore()
                this.displayCountdown()
                
        },     

    getLatestBlock(){
            this.web3.eth.getBlockNumber().then((res) => {
                this.systemEpoch = res
                //console.log('latest block height :', this.systemEpoch)

                setTimeout(() => {

                    let additional = Math.floor(Math.random() * 150);
                    let newBeckoning = parseInt(this.startBeckoning  + (this.systemEpoch - this.startBlock)*9 + additional)
                    
                    if(newBeckoning > this.globalBeckoning)
                    this.globalBeckoning = newBeckoning
                    
                    console.log('global beckoning : ', this.globalBeckoning)

                    this.getLatestBlock()
                    this.displayCountdown()
                }, 3000);


            }).catch((err) => {
                console.log(err, 'err');
            });

    },

    LoadHowToPlay() {
        
        this.ishowToPlay = true

        // load how to play guide 
        this.autoLoadTimer = setTimeout(() => {
            this.ishowToPlay = false
            this.isTabKoban = true
        }, 5000);
        
    },

    newRound(){

        this.round.push({
                winningRoom : Math.floor(Math.random() * 25),
                endGameRoom : 101,
                tokenWin    : 0,
                bottom      : -1,
                upper       : 101,
                status      : true
            })

        console.log('this round is :', this.round[this.round.length - 1].winningRoom + 1)

        if(this.isGameOver == true){
            this.isGameOver = false;
            this.updateGrid()
        }

    },


    async openThisRoom( _room ) { 
        // to select a metapass or as guest

        let passCheck = true

        for(let i =0 ; i< this.myPass.length ; i++ ){
            if(this.myPass[i].id == this.metaPass && this.myPass[i].coolingTime == true) {
                passCheck = false
                this.dialogMetapassExpired = true;
                
            }
        }

        if( this.isMetapass == true  && passCheck== true ){
            if(this.isGameOver==false){

                this.roomOpened = _room;

                let j = this.round.length - 1;

                console.log('selected room :', _room +1)
                let targetRoom = this.round[j].winningRoom

                if(this.round[j].bottom  < _room && this.round[j].upper > _room){

                    if (targetRoom == _room){
                        // Win! end games
                        this.gameWin (_room);

                    } else {
                        // bottom bias check
                        if( targetRoom > this.game.range){
                            if( _room < targetRoom - this.game.range || _room > (targetRoom + this.game.range) ){
                                // safe
                                this.updateAttemptToRound (_room);

                            } else {
                                // Lose! end games
                                // reset to new round
                                this.gameOver (_room);
                            }
                        } else {       
                            if(_room > (targetRoom + this.game.range) ){
                                // safe
                                this.updateAttemptToRound (_room);

                            } else {
                                // Lose! end games
                                // reset to new round
                                this.gameOver (_room);
                            }

                        }

                    }
                } else {
                    console.log('no action!')
                }
            } else {
                this.newRound();
            }
        } else {
            if(passCheck == false){
                this.dialogMetapassExpired = true;
            } else {
            this.isTabGame = false
            this.isTabMetapass = true
            }
        }

    },


    async submitForRewards( _NekoAmount ) { 


        if ( this.Account.epoch + this.coolingBlock < this.systemEpoch){

            if (this.isOwner==true) {

                this.dialogNekoTransfered = true

                await this.contract.beckoning.methods.submit(this.authKey, this.metaPass, _NekoAmount, this.systemEpoch).send({
                    from: this.accountNetwork1,
                }).then((receipt) => {
                    
                    console.log("Sibar txhash: ", receipt)

                    let kobanID = parseInt(receipt.events.ROUND.returnValues._kobanID)

                    if(kobanID>0){
                        console.log('win koban , ', kobanID );
                        this.getWinKoban (kobanID-1)
                    } else {
                        console.log('no koban winner' );
                    }
                    

                    this.isTransferNeko = false
                    this.getAccount()
                            
                    // new round and reset token debit
                    this.newRound()
                    this.updateGrid()
                    this.tokenDebit = 0
                    this.game.tokenFactor = 1
                    this.getGameDetails()
                    this.getTotalRounds()

                    // reset the winning count
                    
                    this.winCount = 0; 

                    this.dialogNekoTransfered = false
                    this.dialogSubmit = false;
                    this.dialogGuestGameOver = false;
                    this.isMyRedemption = true


                    // dialog Payout
                    this.playPayoutSound()

                }).catch((err) => {
                    console.log(err, 'err');
                    });



            } else {
                console.log ('Metapass not valid. cannnot play')
                if (this.timer != 0){
                    console.log ('please wait for ',this.timeDisplay)
                }
            }
        } else {
            // wait for cooling period
            this.dialogSubmit = false
            this.dialogMetapassExpired = true
        }



    },


    updateAttemptToRound (_room){

        let j = this.round.length - 1;

        this.collectedNeko.push({
            round : j,
            nekoAMount : this.game.tokenFactor,
            room : _room
        })
        // wave the hand 
        this.animationManekiNeko ()
       

        // update current round
        if( _room < this.round[j].winningRoom) {
            this.round[j].bottom     = _room;
        } else { 
            this.round[j].upper      = _room;
        }

        // update temporary holding token
        this.tokenDebit += this.game.tokenFactor

        this.playCollectCoinSound()

        // trigger notification 
        //this.openNotification('NEKO ' + this.tokenDebit)

        this.updateGrid()
    },

    animationManekiNeko(){
        this.isManekiFish = false
        this.isManekiNeko = true
        setTimeout(() => {
         this.isManekiNeko = false
        }, 500);

    },

    animationManekiFish(){
        this.isManekiFish = true
        setTimeout(() => {
        this.isManekiFish = false
        }, 3000);

    },

    gameWin ( _room) {
        let j = this.round.length - 1;

        console.log('this round neko Collected: ', this.collectedNeko);

        // update current round 
        this.round[j].endGameRoom    = _room;
        this.round[j].status = false;

        // update temporary holding token
        this.tokenDebit += this.game.tokenFactor
        
        this.playFishSound()

        // wave the hand 
        this.animationManekiFish ()

        this.winCount ++; 

        // submit for rewards
        //if( this.winCount == 3 ){

        //    this.dialogSubmit = true

       // } 

       // increse token Factor x2
       this.game.tokenFactor = this.game.tokenFactor * 2

        this.updateGrid()
        this.isGameOver = true;
       
    },

    gameOver ( _room) {
        let j = this.round.length - 1;

        // update current round 
        this.round[j].endGameRoom    = _room;
        this.round[j].status = false;

        this.life --

            //this.playGameOverSound()
            this.playCashRegister()

            this.setMetapassDesactive(this.metaPass)

            if(this.metaPass!=11000){
                this.dialogSubmit = true
            } else {
                this.dialogGuestGameOver = true

            }


        
        // new round
        this.updateGrid()
    
        this.isGameOver = true;
    },

    async getTotalRounds(){   

    await this.contract.beckoning.methods.totalRounds().call().then((res) => {

        this.totalRounds = res[0];


        console.log('Total rounds :', this.totalRounds);

        //this.getLatestRound(this.totalRounds)

        }).catch((err) => {
            console.log(err, 'err');
        });

    },
    async getNekoRedeemed(){   
        await this.contract.neko.methods.balanceOf(contract_beckoning).call().then((res) => {
            
            let balance = res
            this.nekoRedeemed = (this.nekoStartingDeposit - balance)/1e18

            console.log('Total Neko Redeemed :', this.nekoRedeemed);


        }).catch((err) => {
            console.log(err, 'err');
        });

    },

    async getComboWinners(){   
        await this.contract.beckoning.methods.totalCombos().call().then((res) => {
            
            this.totalCombos = res;

            console.log('totalCombos :', res);

            this.comboWinnerImgMapping()

        }).catch((err) => {
            console.log(err, 'err');
        });

    },

    async comboWinnerImgMapping () {   
        let limit = 0

        if(this.totalCombos > 3){
            limit = this.totalCombos - 4
        }
         for (let i= this.totalCombos  ; i > limit  ; i--){

              await  this.contract.beckoning.methods.Combos(i-1).call().then((res2) => {
                    this.latestCombos.push({
                        winnerWallet: res2[0].toString(),
                        metapass: parseInt(res2[1]),
                        metapassIMG: '',
                        coinPool: parseInt(res2[2]),
                        tokenPool: parseInt(res2[3])
                    })
                }).catch((err) => {
                console.log(err, 'err');
                });
        }
        this.getMetapassImage()
        
    }, 

    async getLatestRound(_latestRound){      

            let flag = 0

            for (let i=_latestRound-3 ; i < _latestRound ; i++){
                await this.contract.beckoning.methods.Rounds(i).call().then((res2) => {
                    console.log('--> ',res2)

                    if(res2[0]== this.accountNetwork1){
                        flag = 1
                    } else {
                        flag = 0
                    }

                    this.latestWinner.push({
                        metapass : flag
                    })

                }).catch((err) => {
                console.log(err, 'err');
                });
            }


    },

    async getAccount (){      

            
        await this.contract.beckoning.methods.walletBalance(this.accountNetwork1).call().then((res) => {

            console.log('cooling block :',parseInt(res[3]) )
            
            this.Account.playerWallet = res[0].toString()
            this.Account.tokenBalance = parseInt(res[1])
            this.Account.coinBalance  = parseInt(res[2])
            this.Account.epoch        = parseInt(res[3])

        }).catch((err) => {
            console.log(err, 'err');
        });
    },

    async getBestScore (){
        await  this.contract.beckoning.methods.getBestScore().call().then((res) => {


            console.log('BestScore ', res ) 

            this.BestScore = (parseInt(res)/1e18).toFixed(0);

            }).catch((err) => {
                console.log(err, 'err');
            });
        
    },
    async getWinKoban (_kobanID){
  
        this.playCashRegister()
        this.playPayoutSound()

        await  this.contract.beckoning.methods.Combos(_kobanID).call().then((res) => {

                console.log('koban :', res)

                this.kobanToken = (parseInt(res[3])/1e18).toFixed(0)
                this.kobanCoin = (parseInt(res[2])/1e18).toFixed(0)


                this.dialogNekoTransfered = false
                this.dialogWinKoban = true
    
        }).catch((err) => {
            console.log(err, 'err');
        });
                            
    },
    async getGameDetails (){
        await  this.contract.beckoning.methods.gamesDetails().call().then((res2) => {
                console.log('game details : ', res2)
                this.game.tokenPoolReward  = (parseInt(res2[0])/1e18).toFixed(0)
                this.game.coinPoolReward   = (parseInt(res2[1])/1e18).toFixed(0)
                this.game.coinFactor       = parseInt(res2[2])/1e18
                //this.game.tokenFactor      = parseInt(res2[3])/1e18
                this.game.tokenFactor      = 1
                this.game.tokenAddress     = res2[4].toString()

            }).catch((err) => {
                console.log(err, 'err');
            });
        
    },
    
    async getRoundDetails (_currentRound){      
        await  this.contract.beckoning.methods.Rounds(_currentRound).call().then((res2) => {

                this.round.winningRoom = parseInt(res2[0])
                this.round.endGameRoom = parseInt(res2[1])
                this.round.lastPlayer  = res2[2]
                this.round.metapass    = parseInt(res2[3])
                this.round.tokenPool   = parseInt(res2[4])
                this.round.bottom      = parseInt(res2[5])
                this.round.upper       = parseInt(res2[6])
                this.round.status      = res2[7]

                if (this.initLoad== false){
                    this.generateGird()
                } else {
                    this.updateGrid()
                }

                this.getAccount();

            }).catch((err) => {
                console.log(err, 'err');
            });

    },


    generateDoor (){
            for (let i = 0; i < 25; i++) {
                this.doors.push ({
                    id : i,
                    color : i
                })
            }
    },

    setMetapassDesactive (_metapass){

        for( let i = 0 ; i < this.myPass.length ; i++ ){
            if(this.myPass[i].id == _metapass){
                this.myPass[i].coolingTime = true
            }
        }

        this.comboMetapass -= 1

    },

    displayCountdown (){
            // Get today's date and time
            //var now = new Date().getTime();

            // Find the distance between now and the count down date
            //var distance = this.countDownDate - now;
            //this.timer = distance;

            
            let block_differance = this.systemEpoch - this.Account.epoch 
            let cooling_height   = this.coolingBlock

            let block_distance = block_differance / cooling_height

            let est_time_disctance = this.estTimeDisctance

            var distance = est_time_disctance - parseInt(block_distance * est_time_disctance)


            //console.log('block distance :',distance)

            // Time calculations for days, hours, minutes and seconds
            //var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Display the result in the element with id="demo"
            //this.timeDisplay = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

            if(distance >3600000) {
                this.timeDisplay =  hours + "h " + minutes + "m " + seconds + "s ";
            } else if (distance >60000) {
                this.timeDisplay =   minutes + "m " + seconds + "s ";
            } else {
                this.timeDisplay =   seconds + "s ";
            }

            // If the count down is finished, write some text
            if (distance < 0) {
                clearInterval(this.clock);
                this.timer = 0;
                this.timeDisplay =''
            }

            //console.log('time display : ', this.timeDisplay)

    },

    generateGird(){
        let j = this.round.length -1;

        if( this.round[j].status==true && this.round[j].bottom == 101 && this.round[j].upper == 101){
            // start game
            for (let i = 0; i < 25; i++) {
                this.doors.push ({
                    id : i,
                    color : 'D0'
                })
            }
        } else if (this.round[j].status==true && this.round[j].bottom != 101 && this.round[j].upper != 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if(i < this.round[j].bottom + 1 || i > this.round[j].upper - 1){
                    this.doors.push ({
                        id : i,
                        color : 'D1'
                    })
                } else {
                    this.doors.push ({
                        id : i,
                        color : 'D2'
                    })
                }
            }
        }  else if (this.round[j].status==true && this.round[j].bottom == 101 && this.round[j].upper != 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if( i > this.round[j].upper - 1){
                    this.doors.push ({
                        id : i,
                        color : 'D1'
                    })
                } else {
                    this.doors.push ({
                        id : i,
                        color : 'D2'
                    })
                }
            }
        }  else if (this.round[j].status==true && this.round[j].bottom != 101 && this.round[j].upper == 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if( i < this.round[j].bottom + 1){
                    this.doors.push ({
                        id : i,
                        color : 'D1'
                    })
                } else {
                    this.doors.push ({
                        id : i,
                        color : 'D2'
                    })
                }
            }
        } else if (this.round[j].status==false) {
            // game over
            if(this.round[j].bottom == 101){
                this.round[j].bottom = -1;
            }

            if(this.round[j].bottom != 101 && this.round[j].upper != 101){
                for (let i = 0; i < 25; i++) {
                    if(i < this.round[j].bottom + 1 || i > this.round[j].upper - 1){
                        this.doors.push ({
                            id : i,
                            color : 'D1'
                        })
                    } else {
                        this.doors.push ({
                            id : i,
                            color : 'D2'
                        })
                    }
                }
            } else {
                for (let i = 0; i < 25; i++) {
                    this.doors.push ({
                        id : i,
                        color : 'D1'
                    })        
                }
            }

            //this.game.range
            // target doors
    
            this.doors[this.round[j].winningRoom].color = 'D4'

            if (this.round[j].winningRoom == this.round[j].endGameRoom){
                this.doors[this.round[j].endGameRoom].color = 'D5A'
            } else {
                this.doors[this.round[j].endGameRoom].color = 'D5B'
            }


        }
        this.initLoad = true;
        //console.log ('the grid ', this.doors)
    },

    updateGrid(){

        let j = this.round.length - 1;

        if( this.round[j].status==true && this.round[j].bottom == 101 && this.round[j].upper == 101){
            // start game
            for (let i = 0; i < 25; i++) {
                    this.doors[i].color = 'D0'
            }
        } else if (this.round[j].status==true && this.round[j].bottom != 101 && this.round[j].upper != 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if(i < this.round[j].bottom + 1 || i > this.round[j].upper - 1){
                    this.doors[i].color = 'D1'
                } else {
                    this.doors[i].color = 'D2'
                }
            }
        }  else if (this.round[j].status==true && this.round[j].bottom == 101 && this.round[j].upper != 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if( i > this.round[j].upper - 1){
                    this.doors[i].color = 'D1'
                } else {
                    this.doors[i].color = 'D2'
                }
            }
        }  else if (this.round[j].status==true && this.round[j].bottom != 101 && this.round[j].upper == 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if( i < this.round[j].bottom + 1){
                    this.doors[i].color = 'D1'
                } else {
                    this.doors[i].color = 'D2'
                }
            }
        } else if (this.round[j].status==false) {
            // game over
            if(this.round[j].bottom == 101){
                this.round[j].bottom = -1;
            }

            if(this.round[j].bottom != 101 && this.round.upper != 101){
                for (let i = 0; i < 25; i++) {
                    if(i < this.round[j].bottom + 1 || i > this.round[j].upper - 1){

                        this.doors[i].color = 'D1'
                    } else {
                        this.doors[i].color = 'D2'
                    }
                }
            } else {
                for (let i = 0; i < 25; i++) {
                        this.doors[i].color = 'D1'
                }
            }

            //this.game.range
            // target doors
            if(this.round[j].bottom == 101){
                this.round[j].bottom = -1;
            }

        

            if (this.round[j].winningRoom == this.round[j].endGameRoom){
                //win
                this.doors[this.round[j].winningRoom].color = 'D5B'
            } else {
                // lose
                this.doors[this.round[j].winningRoom].color = 'D5C'
                this.doors[this.round[j].endGameRoom].color = 'D5A'
            }


        }
        console.log("this.collectedNeko, ", this.collectedNeko)
        console.log("this J, ", j)


        // change room that collected Neko 
        for(let i=0 ; i<this.collectedNeko.length ;  i++ ){

            if(this.collectedNeko[i].round == j){

            
                console.log("this.collectedNeko[i].door", this.collectedNeko[i].room)

                //this.doors[this.round[j].winningRoom].color = 'D5C'
                this.doors[this.collectedNeko[i].room].color = 'DNEKO'
            }

        }



        //console.log ('the grid ', this.doors)
    },
    
    async getMetapassImage(){
        
        for(let i = 0 ; i < this.latestCombos.length ; i++) {

                await contract_nft_meow.tokenURI(this.latestCombos[i].metapass).then((res) => {
                     this.getMetapassIMGURL(res, i);
                }).catch((err) => {
                    console.log(err, 'err');
                });
        }

            console.log ('preview', this.latestCombos )
    },

    async getMetapassIMGURL(_url, _i){
        const axios = require('axios');
        await axios.get(_url).then((metadata) => {
            console.log('getMetapassIMGURL', metadata.data.image);
            this.latestCombos[_i].metapassIMG = metadata.data.image;
        })
        .catch(function (error) {
            console.log(error);
        });
    },

    async getURI(){
        console.log('token id :', this.metaPass);
        this.form.guardian = this.metaPass;

        if(this.metaPass < 10010){

            await contract_nft_meow.tokenURI(this.metaPass).then((res) => {
                console.log('token URI : ', res);
                this.getIMG(res);
                //this.getGuardian(this.NFT.id)
            }).catch((err) => {
                console.log(err, 'err');
            });
        }
    },        
    
    async getIMG(_url){
        const axios = require('axios');
        await axios.get(_url).then((metadata) => {
            console.log(metadata);
            console.log(metadata.data.image);
            this.nftImageURL = metadata.data.image;
            console.log('this.nftImageURL', this.nftImageURL);
            //this.nftImageURL = metadata.data.image;
        })
        .catch(function (error) {
            console.log(error);
        });
    },

    selectMetapass(_id) {

        this.metaPass = _id
        this.getURI();
        this.isMetapass = true;
        this.isOwner = true;
        console.log('selected metapass :', _id)
        
        this.isTabMode = false
        this.isTabGame = true
        this.isTabMetapass = false
        this.isTabKoban = false
        this.ishowToPlay = false

        if(this.metaPass !=11000 && this.Account.epoch + this.coolingBlock > this.systemEpoch){
            this.dialogMetapassExpired = true
        }


        let validPass = true

        for(let i=0; i<this.myPass.length ; i++ ){
            if(this.myPass[i].id == _id && this.myPass[i].coolingTime == true ){
                validPass = false
            }
        }
        if(validPass == true ){
            this.life = 3
        } else {
            this.life = 0
        }
    },
    async getMyMetapass (){       

        await contract_nft_meow.ownedNekos().call({
            from: this.accMainnetCore,
        }).then((res) => {

            this.pumpMyPass (res);

        }).catch((err) => {
            console.log(err, 'err');
        });



    },
    async pumpMyPass (_receivedPass ){

         const axios = require('axios');
         for(let i = 0; i < _receivedPass.length; i++){

              await  contract_nft_meow.tokenURI(parseInt(_receivedPass[i])).then(res2 => {

                    axios.get(res2).then((metadata) => {
    
                        // store 
                        this.myPass.push({
                            id : parseInt(_receivedPass[i]),
                            img : metadata.data.image,
                            coolingTime : 0
                        })

                    })
                }).catch((err) => {
                    console.log(err, 'err');
                });
            }

       console.log ('My Metapassas json :', JSON.parse(JSON.stringify(this.myPass)))

    },

    changeMetapass(){
        this.isTabMetapass = true
        this.isTabGame = false
        this.dialogLuckyPacket = false
        this.dialogMetapassExpired = false
        this.dialogNekoTransfered = false
        this.dialogGuestGameOver = false
        this.dialogWinKoban = false
        this.dialogSubmit = false
    },

    async isMetapassOwner (){
        if( this.metaPass != 10010){

            await contract_nft_meow.ownerOf(this.metaPass).call().then((res) => {
                this.NFT.owner = res;
            })

            if (this.NFT.owner == this.accMainnetCore) {
                this.isOwner = true;
                //console.log('this is the owner');
            } else {
                //console.log('this is not the owner');
            }
        }
    },


        async getNekoTokenBalance (){      
            await contract_neko.balanceOf(this.accAddress).then((res) => {
                console.log('Balance $NEKO:', (res.toString()/1e18).toFixed(2));
                this.accountNekoBalance = (res.toString()/1e18).toFixed(2);
            }).catch((err) => {
                console.log(err, 'err');
            });
        },

        async getNFTBalance (){
            const balance = await contract_nft_meow.balanceOf(this.accAddress);
            
            this.accountNFTBalance = balance[0];
            console.log('Total Guardian Owned:',balance); 
        },

        async getNFTDetails(){
            if(this.metaPass > 0 && this.metaPass < 10010){
            await contract_nft_meow.Nekos(this.metaPass).call().then((res) => {

                this.NFT.id           = this.metaPass;
                this.NFT.power        = res[0]; 
                this.NFT.DNA          = res[1];
                this.NFT.refCount     = parseInt(res[2]);
                this.NFT.gamma        = parseInt(res[3]);
                this.NFT.piggyBank    = parseInt(res[4].toString()/10**18).toLocaleString() ;
                this.NFT.lastPrice    = parseInt(res[5].toString()/10**18).toLocaleString() ;

                console.log('Blessing used: ', parseInt(res[2]));

                this.getGuardian()
                
            })    
            }

        },

        getGuardian (){
            this.newNFT.guardian = this.metaPass;

            // require to retrive from the metadata
            this.newNFT.guardianIMG = path_Image + this.metaPass + '.gif'
            this.form.guardian = this.metaPass;

            console.log('Guardian id : ', this.metaPass);
        },




// Retrieve General Information
    async getNeko(){

        await contract_neko.balanceOf(contract_nft_meow.address).then((res) => {
            this.poolBalance = (res.toString()/1e18).toFixed(5);
            console.log('Collectible Contract $NEKO Bal :',(res.toString()/1e18).toFixed(5));
        }).catch((err) => {
            console.log(err, 'err');
        });
    },
    async getGeneralDetails(){
        await contract_nft_meow.balanceOf(this.account).call().then((res) => {
            this.NFT.balance = parseInt(res);
            console.log('No. NFT owned :', parseInt(res));
        }).catch((err) => {
            console.log(err, 'err');
        });
    },
    checkNetworkID(){


        this.web3.eth.getId().then((res) => {
            console.log('network id: ', res);
            //console.log('async accountNekoBalance :', res);
        }).catch((err) => {
            console.log(err, 'err');
        });
    },


    goTabMetapass(){
        this.isTabGame = false
        this.isTabMetapass = true
    }



  }
}
</script>

<style scoped>

.mint_container {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -21px;
    right: -17px;
    overflow-y: scroll;
}

h2 {
    padding:10px 35px;
    margin:0;
    color:#12bc00;
    font-size: 1.5em;;
}

.metapass-logo{
    padding:3px 36px;
    width:250px;
}
.guest-pass {
    background: white;
    width:165px;
    height:90px; 
    margin-top:15px; 
    margin-left:65px; 
    border:2px solid #12bc00; 
    background-image: url('../../src/assets/images/Maneki Street_Guest.png');
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 10px 10px 0 0;
}
.tab-game {
    width: 478px;
    height: 719px;
    background-image: url('../../src/assets/images/ManekiGames_bg.png');
    background-size: cover; /* Resize the background image to cover the entire container */
    border: none;
    margin:0 auto;
}
.games_details {
    height:160px;
    width:483px;
}
.pool_neko {
    line-height: 90px;
    font-size:2.5em;
    font-weight: 600;
    width: 150px;
    height: 60px;
    margin-left:80px;
    text-align: center;
    padding-bottom: 15px;
}
.myRedepmtion {
    font-size:0.8em;
    width: 90px;
    height: px;
    margin-left: 255px;
    margin-top:-30px;
    text-align: center;
    line-height: 30px;

}
.blockheight {
    font-size:0.8em;
    width: 100px;
    height: 30px;
    margin-left:160px;
    text-align: center;
    line-height: 35px;

}

.latestWinner {
    font-size:1.8em;
    font-weight: 600;
    width: 90px;
    height: 40px;
    line-height: 40px;
    margin-left:300px;
    margin-top: -63px;
    text-align: center;
}
.panel-play{
    height:559px;
    width:483px;
    background-image: url('../../src/assets/images/ManekiGames_upper.png');
    background-size: cover; /* Resize the background image to cover the entire container */

}
.metapass_status {
    float: left;
    margin-left:64px;
    margin-top:60px;
    color: black;
    height:32px;
    width:166px;
    text-align: center;
    vertical-align:middle;
    line-height: 33px;
}
.round_details{
    height:95px;
    width:483px;
}
.win_count{
    height:50px;
    line-height: 80px;
    width:140px;
    background-repeat: no-repeat;
    background-position: left;
    text-align: right;
    font-size:1.5em;
    float:right;
    margin-right:100px;
    margin-top:-32px;
    color: #12bc00;
}
.tokenDebit {
    height:30px;
    width:143px;
    text-align: right;
    font-size:1.3em;
    padding-top:40px;
    margin-left:242px;
    color:white;
    font-weight: 600;
}
.doors {
    width:435px;
    list-style: none;
    color:#000;
    margin: 0;
    padding: 0 24px;
}
.doors li {
    border: 1px solid #12bc00;
    text-align: center;
    line-height: 85px;
    vertical-align: middle;
    width:85px;
    height:85px;
    float:left;
}
.internal-popout {
    position: absolute; 
    margin-left:38px; 
    margin-top:-600px; 
    width:400px; 
    height:430px; 
    background-color: #fff8e6;
    border:5px solid #ff4e00;
    border-radius: 20px;
}

.internal-popout-metapass {
    position: absolute; 
    margin-top:-210px;
    margin-left:38px; 
    width:400px; 
    height:430px; 
    background-color: #fff8e6;
    border:5px solid #ff4e00;
    border-radius: 20px;

}





.D0 {
    background: #0086ff;
}
.D1 {
    background: #eaeaea;
    color : #eaeaea;
}
.D2 {
    background: white;
}
.D3 {
    background: black;
}
.D4 {
    background: white;
    color: green;
}
.D5A {
    background-image: url('../../src/assets/images/ManekiGames_icon-wallet.png');
    background-repeat: no-repeat;
    color : transparent;
}
.D5B {
    background-image: url('../../src/assets/images/ManekiGames_icon-win.png');
    background-repeat: no-repeat;
    color : transparent;
    background-color: #12bc00;
}
.D5C {
    background-image: url('../../src/assets/images/ManekiGames_icon-win.png');
    background-repeat: no-repeat;
    color : transparent;
}
.DNEKO {
    background-image: url('../../src/assets/images/ManekiGames_icon-nekotoken.png');
    background-repeat: no-repeat;
    color : transparent;
}

h1{
    width: 25%;
    font-size: 2em;
    color:rgba(255, 255, 0, 0.7);
    margin:0 auto;
    font-weight: 100;
    margin-bottom: 20px;
    text-align: center;
}

.content-tab{
    margin:0 auto;
    padding-top: 10px;
    width:478px;
}
.title-tab img {
    float:left;
    width: 100px;
    padding:10px;
}
.title-tab h1 {
    float:left; 
    text-align: left;
    width: 400px;
    padding:10px;
}
.tab-mode{
    color:black;
    width: 478px;
    min-height: 530px;
    background: white;
    border: none;
    border-radius: 20px;
    margin:0 auto;
    margin-bottom : 30px;

}

.tab-metapass {
    color:black;
    width: 478px;
    min-height: 530px;
    background: white;
    border: none;
    border-radius: 20px;
    margin:0 auto;
    margin-bottom : 30px;
}
.tab-mode ul {
    padding:40px;
    margin:0 auto;
    width:420px;
}
.tab-mode li{
    width:180px;
    height: 230px;
    opacity: 1;
    list-style: none;
    color: black;
    border: 1px solid #12bc00;
    border-radius: 5px;
    float:left;
    margin-right:15px;
    margin-bottom: 30px;
    padding:5px;
}
.tab-metapass ul {
    padding:15px 40px;
    margin:0 auto;
    width:420px;
}
.tab-metapass li{
    width:180px;
    height: 220px;
    opacity: 1;
    list-style: none;
    color: black;
    border: 1px solid #12bc00;
    border-radius: 5px;
    float:left;
    margin-right:15px;
    margin-bottom: 30px;
    padding:5px;
}
.tab-howToPlay{
    background-image: url('../../src/assets/images/Maneki-start.png');
    color:black;
    width: 478px;
    height: 480px;
    float:right;
    border: none;
    border-radius: 20px;
    margin: 0 5px;
    margin-bottom:100px;

}
.tab-start-empty{
    background-image: url('../../src/assets/images/Maneki-start-empty.png');
    color:black;
    width: 478px;
    height: 480px;
    float:right;
    border: none;
    border-radius: 20px;
    margin: 0 5px;
    margin-bottom:100px;

}

.tab-koban {
    background: white;
    color:black;
    width: 478px;
    min-height: 530px;
    float:right;
    border: none;
    border-radius: 20px;
    margin: 0 5px;
    margin-bottom:100px;
}
.tab-koban-top {
    width: 478px;
    height: 270px;
    background-image: url('../../src/assets/images/Maneki-result.png');
    border-radius: 20px 20px 0 0;
}
.koban-winners ul {
    padding:20px;
    margin:0;
}
.koban-winners li{
    height: 70px;
    opacity: 1;
    list-style: none;
    color: white;
    background: #ff4e00;
    border-radius: 50px;
    padding:5px 5px;
    margin: 10px 0;
}
.koban-winners a:link {
  text-decoration: none;
}


.dialog-container {
    width:1000px;
    min-height: 1000px;
    margin:0 auto;
}

.dialog-wrap {
    border:1px solid red;
    min-height: 300px;
    text-align: center;
    font-size:3em;
    color:black;
    background: white;
    border-radius: 20px;
}
.dialog-wrap img {
    width:200px;
}
.el-icon-picture{
    width:195px;
    height: 95px;
    background-image: url('../../src/assets/images/slot-in.png');
}

.el-icon-picture:before {
    content:none;
}
.gashapon{
    width:293px;
    height:462px;
    background-image: url('../../src/assets/images/gashapon.png');
    margin: 0 auto;
}
.gashapon:hover{
    width:293px;
    height:462px;
    background-image: url('../../src/assets/images/gashapon.png');
    margin: 0 auto;
    margin-top : 3px;
}
.el-button--gashapon {
    background-color: yellow;
    color:tomato;
    border: 1px solid tomato;
}
.dialog-input-wrap{
    width:478px; 
    height:420px;
    margin:0 auto; 
    padding-bottom:15px; 
    padding-top:20px; 
    padding-left:20px; 
    padding-right:20px; 
    border:1px solid #000;  
    background:rgba(0, 0, 99, 0.8);  
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    border-radius: 5px;
}
.dialog-content{
    height:300px;
}
.dialog-footer-msg{
    color:white;
}
.btn_twister{
    cursor: pointer;
}

.btn_twister:hover{
  -webkit-transform:rotate(110deg);
  -moz-transform: rotate(110deg);
  -ms-transform: rotate(110deg);
  -o-transform: rotate(110deg);
  transform: rotate(110deg);
}

.dailog_payment {
    text-align: center;
}
.dialog-footer {
    text-align: center;
}
.dialog-footer a{
    text-decoration: none;
    color:#ff3600;;
    padding:5px;
}
.metapass-wallet-connection{
    border: 2px solid #12bc00;
    border-radius: 5px;
    width: 400px;
    height:80px;
    margin:0 auto;
}
.meow-balance {
    text-align: left;
    vertical-align: middle;
    background-image: url("../../src/assets/images/Maneki Street_Metapass.png");
    background-repeat: no-repeat;
    font-size: 2.7em;

    background-position: 0px 0px; 
    background-size : 70px 70px;
    line-height:70px ;
    padding-left:80px;
    padding-right:50px;
    width:350px;
    margin-left:20px;
    color:black;
}
.token-wrap{
    width: 460px;
    height: 30px;
    padding:20px;
    margin-top:-20px;
    background: #3f3f3f;
    border-radius: 0 0 10px 10px;
    background:rgba(0, 0, 0, .4); 
    border:solid 1px #0086ff;
}
.redeemRow {
    background: white;
    border-radius: 20px;
    text-align: left;
    background-repeat: no-repeat;
    background-position: 2px 2px; 
    background-size : 40px 40px;
    padding:5px;
    padding-left:50px;
    min-height: 35px;
    width:250px;
    margin-left:50px;
    font-size: 1.5em;
    color: black;
    border:1px solid #CCC;
}
.cfx-balance {
    background-image: url("../../src/assets/images/icon-cfx.png");
}
.neko-balance {
    background-image: url("../../src/assets/images/icon-neko.png");
    margin-bottom:10px;
}

@media only screen and (max-width: 428px)  {
.tab-general {
    transform: scale(0.82, 0.82); /* Equal to scaleX(2) scaleY(0.5) */
    transform-origin: top center;
}
}
@media only screen and (max-width: 390px)  {
.tab-general {
    transform: scale(0.80, 0.80); /* Equal to scaleX(2) scaleY(0.5) */
    transform-origin: top center;
}
}
@media only screen and (max-width: 384px)  {
.tab-general {
    transform: scale(0.78, 0.78); /* Equal to scaleX(2) scaleY(0.5) */
    transform-origin: top center;
}
}
@media only screen and (max-width: 375px)  {
.tab-general {
    transform: scale(0.78, 0.78); /* Equal to scaleX(2) scaleY(0.5) */
    transform-origin: top center;
}
}


@media only screen and (max-width: 360px)  {
.tab-general {
    transform: scale(0.73, 0.73); /* Equal to scaleX(2) scaleY(0.5) */
    transform-origin: top center;
}
}
</style>